<template>
  <div class="factory">
    <nav-header :navs="7" :navsitems="23" />
    <div class="contents">
      <div class="in-banner">
        <img
            src="../../assets/image/1-1.jpg"
            width="100%"
            height="auto"
        />
      </div>
      <transition>
        <div class="pageBox waps">
          <div class="pagetits">荣誉证书</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="Factorys-centers">
              <el-row>
                <el-col :lg="6" :md="8" :sm="12" :xs="12" v-for="(val, index) in honor.datalist" :key="index">
                  <div class="Factorys-items" :title="val.tilte">
                    <img v-if="val.image.indexOf('http') != -1"
                         :src="val.image" style="width: 100%; height: auto" :preview-src-list="[val.image]"
                    />
                    <img v-else :src="`http://www.jiukaist.com${val.image}`" style="width: 100%; height: auto" :preview-src-list="[`http://www.anjpower.com${val.image}`]" />
                    <p class="text">{{ val.tilte }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="el-pages">
            <el-pagination
                background
                @current-change="handleCurrentHonors"
                :current-page="honor.page"
                :page-size="honor.pagesize"
                layout="total,prev,pager,next"
                :total="honor.total"
            >
            </el-pagination>
          </div>
        </div>
      </transition>
      <transition>
        <div class="pageBox waps">
          <div class="pagetits">发明专利</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="Factorys-centers">
              <el-row>
                <el-col  :lg="6" :md="8" :sm="12" :xs="12" v-for="(val, index) in patent.datalist" :key="index">
                  <div class="Factorys-items" :title="val.tilte">
                    <img v-if="val.image.indexOf('http') != -1"
                         :src="val.image" style="width: 100%; height: auto" :preview-src-list="[val.image]"
                    />
                    <img v-else :src="`http://www.jiukaist.com${val.image}`" style="width: 100%; height: auto" :preview-src-list="[`http://www.anjpower.com${val.image}`]" />
                    <p class="text">{{ val.tilte }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="el-pages">
            <el-pagination
                background
                @current-change="handleCurrentPatent"
                :current-page="patent.page"
                :page-size="patent.pagesize"
                layout="total,prev,pager,next"
                :total="patent.total"
            >
            </el-pagination>
          </div>
        </div>
      </transition>
      <transition>
        <div class="pageBox waps">
          <div class="pagetits">实用新型专利</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="Factorys-centers">
              <el-row>
                <el-col :lg="6" :md="8" :sm="12" :xs="12" v-for="(val, index) in utility_patent.datalist" :key="index">
                  <div class="Factorys-items" :title="val.tilte">
                    <img v-if="val.image.indexOf('http') != -1"
                         :src="val.image" style="width: 100%; height: auto" :preview-src-list="[val.image]"
                    />
                    <img v-else :src="`http://www.jiukaist.com${val.image}`" style="width: 100%; height: auto" :preview-src-list="[`http://www.jiukaist.com${val.image}`]" />
                    <p class="text">{{ val.tilte }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="el-pages">
            <el-pagination
                background
                @current-change="handleCurrentUpatent"
                :current-page="utility_patent.page"
                :page-size="utility_patent.pagesize"
                layout="total,prev,pager,next"
                :total="utility_patent.total"
            >
            </el-pagination>
          </div>
        </div>
      </transition>
      <transition>
        <div class="pageBox waps">
          <div class="pagetits">计算机软件著作权</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="Factorys-centers">
              <el-row>
                <el-col :lg="6" :md="8" :sm="12" :xs="12" v-for="(val, index) in copyright.datalist" :key="index">
                  <div class="Factorys-items" :title="val.tilte">
                    <img v-if="val.image.indexOf('http') != -1"
                         :src="val.image" style="width: 100%; height: auto" :preview-src-list="[val.image]"
                    />
                    <img v-else :src="`http://www.jiukaist.com${val.image}`" style="width: 100%; height: auto" :preview-src-list="[`http://www.anjpower.com${val.image}`]" />
                    <p class="text">{{ val.tilte }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="el-pages">
            <el-pagination
                background
                @current-change="handleCurrentgetCopyright"
                :current-page="copyright.page"
                :page-size="copyright.pagesize"
                layout="total,prev,pager,next"
                :total="copyright.total"
            >
            </el-pagination>
          </div>
        </div>
      </transition>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "about",
  data() {
    return {
      //荣誉证书
      honor:{
        page:1,
        pagesize:8,
        total:0,
        type:'55',
        datalist:[]
      },
      //发明专利
      patent:{
        page:1,
        pagesize:8,
        total:0,
        type:'57',
        datalist:[]
      },
      //实用新型专利
      utility_patent:{
        page:1,
        pagesize:8,
        total:0,
        type:'59',
        datalist:[]
      },
      //计算机软件著作权
      copyright:{
        page:1,
        pagesize:8,
        total:0,
        type:'61',
        datalist:[]
      },
    };
  },
  components: {
    NavHeader,
    NavFooter,
  },
  mounted() {},
  created() {
    let self = this;
    document.documentElement.scrollTop='0px'
    self.getHonors(self.honor);
    self.getHonors(self.patent);
    self.getHonors(self.utility_patent);
    self.getHonors(self.copyright);

  },
  methods: {
    getHonors(param) {
      this.$api.mall
          .getHonor({
            page: param.page,
            limit: param.pagesize,
            type:param.type
          })
          .then((ress) => {
            let res = ress.data.data.data;
            param.datalist = res;
            param.total =  ress.data.data.total;
          });
    },
    handleCurrentHonors(val) {
      this.honor.page = val;
      this.getHonors(this.honor)
    },
    handleCurrentPatent(val) {
      this.patent.page = val;
      this.getHonors(this.patent)
    },
    handleCurrentUpatent(val) {
      this.utility_patent.page = val;
      this.getHonors(this.utility_patent)
    },
    handleCurrentgetCopyright(val) {
      this.copyright.page = val;
      this.getHonors(this.copyright)
    },
  },
};
</script>
<style lang="scss" scoped>
.factory {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    min-width: 1350px;
    padding-top: 75px;
    .el-pages{
      width: 100%;
      margin: 20px auto;
      overflow: hidden;
      text-align: center;
    }
    .waps {
      width: 90%;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 4% 0 2%;
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      .Factorys-centers {
        width: 100%;
        margin: 0px auto;
        box-sizing: border-box;
        padding: 8px;
        .Factorys-items {
          position: relative;
          height: 410px;
          box-sizing: border-box;
          margin: 5px;
          box-shadow: 0 0 10px 0 #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            padding: 0 5px;
            position: absolute;
            bottom: 0px;
            width: calc(100% - 10px);
            left: 0px;
            height: 38px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 38px;
            overflow: hidden;
            text-wrap: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }
        .txts {
          float: right;
          width: calc(100% - 480px);
          line-height: 2em;
          font-family: 微软雅黑;
          font-size: 16px;
          color: #000000;
        }
        .txt {
          float: right;
          width: calc(100% - 480px);
          line-height: 1.5em;
        }
      }
      .pagetits {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
      }

      .pagetit {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      height: 780px;
      overflow: hidden;
      margin: 0px auto;
    }
  }
  @media screen and(max-width:768px){
    .contents{
      padding-top: 60px!important;
      min-width: unset!important;
	  min-height: 600px;
    }
    .waps{
      width: calc(100% - 30px)!important;
      max-width: unset!important;
    }
    .pageBox{
      padding: 15px 0!important;
    }
    .Factorys-items{
      width: 80%!important;
      height: 140px!important;
      margin-left: 10px!important;
      margin-bottom:15px!important;
      img{
        width: 100%!important;
        height: 100%!important;
        object-fit: contain!important;
      }
    }
    .text{
      width: 100% !important;
      left: 0px !important;
      bottom: 0px !important;
    }
    .in-banner {
      height:unset!important;
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      img{
        width: 100%;
      }
    }
  }
}
</style>
